import common from "./common";

export default {

    downloadByUrl:function (url, name) {
        var _this = this;
        if (common.isIOS()||common.isWx()) { //移动端,或点击显示
            // window.open(url)
            window.open(url,'_blank')
        }else {
            this.getBlobFromUrl(url , function(blob){
                _this.downFileBlob(blob, name)
            });
        }
    },

    getBlobFromUrl:function (url, cb) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.onload = function() {
            if (this.status == 200) {
                if(cb) cb(this.response);
            }
        };
        xhr.send();
    },


    downFileBlob: function (blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
        }
    },



}
